// Typelizer digest 1b0dc5d3e6b345c941bc03dfbc458ccc
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /educators/teachers/:teacher_id/classes */
  index: (
    params: { teacherId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/classes', params, options),
    method: 'get',
  }),

  /** POST /educators/teachers/:teacher_id/classes */
  create: (
    params: { teacherId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/classes', params, options),
    method: 'post',
  }),

  /** GET /educators/teachers/:teacher_id/classes/new */
  new: (
    params: { teacherId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/classes/new', params, options),
    method: 'get',
  }),

  /** GET /educators/teachers/:teacher_id/classes/:id/edit */
  edit: (
    params: { teacherId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/classes/:id/edit', params, options),
    method: 'get',
  }),

  /** PATCH /educators/teachers/:teacher_id/classes/:id */
  update: (
    params: { teacherId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/classes/:id', params, options),
    method: 'patch',
  }),

  /** DELETE /educators/teachers/:teacher_id/classes/:id */
  destroy: (
    params: { teacherId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/classes/:id', params, options),
    method: 'delete',
  }),
}
